var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6C21.2833 6 21.5208 6.09583 21.7125 6.2875C21.9042 6.47917 22 6.71667 22 7V17C22 17.2833 21.9042 17.5208 21.7125 17.7125C21.5208 17.9042 21.2833 18 21 18C20.7167 18 20.4792 17.9042 20.2875 17.7125C20.0958 17.5208 20 17.2833 20 17V7C20 6.71667 20.0958 6.47917 20.2875 6.2875C20.4792 6.09583 20.7167 6 21 6ZM5.825 11L17 11C17.2833 11 17.5208 11.0958 17.7125 11.2875C17.9042 11.4792 18 11.7167 18 12C18 12.2833 17.9042 12.5208 17.7125 12.7125C17.5208 12.9042 17.2833 13 17 13L5.825 13L8.7 15.9C8.88333 16.0833 8.97917 16.3125 8.9875 16.5875C8.99583 16.8625 8.9 17.1 8.7 17.3C8.51667 17.4833 8.28333 17.575 8 17.575C7.71667 17.575 7.48333 17.4833 7.3 17.3L2.7 12.7C2.6 12.6 2.52917 12.4917 2.4875 12.375C2.44583 12.2583 2.425 12.1333 2.425 12C2.425 11.8667 2.44583 11.7417 2.4875 11.625C2.52917 11.5083 2.6 11.4 2.7 11.3L7.3 6.7C7.48333 6.51667 7.7125 6.425 7.9875 6.425C8.2625 6.425 8.5 6.51667 8.7 6.7C8.9 6.9 9 7.1375 9 7.4125C9 7.6875 8.9 7.925 8.7 8.125L5.825 11Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close-menu.55b38ca2c5de0075e5b537b6192f8f2a.svg";
export { ForwardRef as ReactComponent };